import { useQuery } from "@tanstack/react-query";
import api from "apis";

const useTagsByDocumentCategoryQuery = (documentCategoryUuid: string) => {
  return useQuery({
    queryKey: api.tag.getTagsByDocumentCategoryKey(documentCategoryUuid),
    queryFn: () => api.tag.getTagsByDocumentCategory(documentCategoryUuid),
    select: (res) => res.data.result,
  });
};

export default useTagsByDocumentCategoryQuery;
